$(document).ready(function(){
 $(".default-description").appendTo("#collapse-tab3");
//     setTimeout(function(){
        $("[data-target=#collapse-tab3]").trigger('click');
//     }, 2000);
})
setTimeout(
  function() 
  {
     $(".snptwdgt-rtd__fottrr").removeAttr('style');
 }, 9000);

// START FAQ Accordion JS by Royal Weblab
$(document).ready(function(){
  $('.accordion-list > li > .answer').hide();
    
  $('.accordion-list > li').click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").find(".answer").slideUp();
    } else {
      $(".accordion-list > li.active .answer").slideUp();
      $(".accordion-list > li.active").removeClass("active");
      $(this).addClass("active").find(".answer").slideDown();
    }
    return false;
  });
  // START Copyright dynamic date JS
  let d = new Date();
  let year = d.getFullYear();
  $('.year').append(year);
  // END Copyright dynamic date JS
  if ($(window).width() < 767){
$('.site-footer .col-footer .quick-links-wrapper ul').hide();
  
  $('.site-footer .col-footer:nth-child(2)').on('click',function(){
          $(this).find('.quick-links-wrapper').addClass('active');
          $('.site-footer .col-footer:nth-child(3)').find('.quick-links-wrapper').removeClass('active');
          $('.site-footer .col-footer:nth-child(4)').find('.quick-links-wrapper').removeClass('active');
          $(this).find('.quick-links-wrapper ul').slideDown();
          $('.site-footer .col-footer:nth-child(3)').find('.quick-links-wrapper ul').slideUp();
          $('.site-footer .col-footer:nth-child(4)').find('.quick-links-wrapper ul').slideUp();
  })
  $('.site-footer .col-footer:nth-child(3)').on('click',function(){
          $(this).find('.quick-links-wrapper').addClass('active');
          $('.site-footer .col-footer:nth-child(2)').find('.quick-links-wrapper').removeClass('active');
          $('.site-footer .col-footer:nth-child(4)').find('.quick-links-wrapper').removeClass('active');
          $(this).find('.quick-links-wrapper ul').slideDown()
          $('.site-footer .col-footer:nth-child(2)').find('.quick-links-wrapper ul').slideUp();
          $('.site-footer .col-footer:nth-child(4)').find('.quick-links-wrapper ul').slideUp();
  })
  $('.site-footer .col-footer:nth-child(4)').on('click',function(){
          $(this).find('.quick-links-wrapper').addClass('active');
          $('.site-footer .col-footer:nth-child(2)').find('.quick-links-wrapper').removeClass('active');
          $('.site-footer .col-footer:nth-child(3)').find('.quick-links-wrapper').removeClass('active');
          $(this).find('.quick-links-wrapper ul').slideDown()
          $('.site-footer .col-footer:nth-child(2)').find('.quick-links-wrapper ul').slideUp();
          $('.site-footer .col-footer:nth-child(3)').find('.quick-links-wrapper ul').slideUp();
  })
  // $('.site-footer .col-footer').on('click',function(){
  //   $('.site-footer .quick-links-wrapper').removeClass('active')
  // }
}
});
// END FAQ Accordion JS by Royal Weblab